import { DataEntity } from '@barthauer/abc/graphics/adapters/open-layers';
import { RouteConfiguration } from '@barthauer/basys/map-frame';
import { ComponentDataSource, DataSourceFilter } from '../models/componentDataSource.model';
import { IMobileTicket, MobileTicketViewModel } from '../viewModels/mobileData.tickets.viewModel';
import { ListDataSource, ListDataSourceItem } from '../viewModels/mobileData.viewModel';
import { TicketsService } from './tickets.service';

export class TicketConstants {
  public static readonly ObjectTypeName_MtTicket: string = 'MtTicket';
  public static readonly ObjectTypeName_MtTicketTask: string = 'MtTicketTask';
  public static readonly PersistenceCategory_TicketDetail: string = 'Tickets';
}

export class TicketsDataContext {
  dataSource: ComponentDataSource<IMobileTicket>;
  statusListDataSource: ListDataSource;
  selectedTicketStates: string[];

  constructor(private ticketsService: TicketsService) {
    this.selectedTicketStates = [TicketState.Offen, TicketState.InBearbeitung, TicketState.Erledigt, TicketState.Push];
  }
  applyFilterObject(dsFilter: DataSourceFilter) {
    this.dataSource.addFilter(dsFilter);
    this.ticketsService.raiseTicketStateChanged({
      type: TicketStateChangeArgType.TicketsFilterApplied,
    });
  }
  resetFilter() {
    this.selectedTicketStates = [TicketState.Offen, TicketState.InBearbeitung, TicketState.Erledigt, 'ReminderFilter'];
    this.dataSource.resetFilter();
  }
  updateFilter() {
    this.dataSource.updateFilter();
  }
}

export class TicketNavigationContext {
  ticketDataContext: TicketsDataContext;
  ticketIndex?: number;
  sourceRoute?: RouteConfiguration;

  get ticket(): MobileTicketViewModel {
    let ticket = null;
    if (this.ticketIndex || this.ticketIndex === 0) {
      ticket = this.ticketDataContext.dataSource.data[this.ticketIndex];
    }
    return ticket;
  }
}

export class TicketViewPackage {
  allTickets: MobileTicketViewModel[];
  statusListDataSource: ListDataSource;
  dringlichkeitListDataSource: ListDataSource;
  currentUserResourceId: string;
  kategorieListDataSource: ListDataSource;
  personnelResourcesDataSourceItems: ListDataSourceItem[];
  filterEntities: DataEntity[];
  allTicketsFilteredByEntities: MobileTicketViewModel[];
}

export enum TicketState {
  Offen = '0',
  InBearbeitung = '1',
  Erledigt = '2',
  Push = '3',
}

export enum TicketTaskState {
  NichtBegonnen = '0',
  InBearbeitung = '1',
  Erledigt = '2',
}

export enum TicketStateChangeArgType {
  TicketsFilterApplied,
}
export class TicketStateChangeArg {
  type: TicketStateChangeArgType;
}
